/* eslint-disable import/no-anonymous-default-export */

export default [
  {
    title: "Andela",
    subtitle: "Software Engineer",
    period: "July 2020 - Present",
    description:
      "Through Andela Technical and Leadership Programm (ATLP), we learnt as we were working on projects, we used Nodejs/express for developing backend and Reactjs for developing front-end",
  },
];
